var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C6.9 0 6 0.9 6 2V30C6 31.1 6.9 32 8 32H28C29.1 32 30 31.1 30 30V8L22 0H8Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8H30L22 0V6C22 7.1 22.9 8 24 8Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14L24 8H30V14Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26C26 26.55 25.55 27 25 27H3C2.45 27 2 26.55 2 26V16C2 15.45 2.45 15 3 15H25C25.55 15 26 15.45 26 16V26Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35889 18.947C6.35889 18.683 6.56689 18.395 6.90189 18.395H8.74889C9.78889 18.395 10.7249 19.091 10.7249 20.425C10.7249 21.689 9.78889 22.393 8.74889 22.393H7.41389V23.449C7.41389 23.801 7.18989 24 6.90189 24C6.63789 24 6.35889 23.801 6.35889 23.449V18.947ZM7.41389 19.402V21.394H8.74889C9.28489 21.394 9.70889 20.921 9.70889 20.425C9.70889 19.866 9.28489 19.402 8.74889 19.402H7.41389Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2908 24C12.0268 24 11.7388 23.856 11.7388 23.505V18.963C11.7388 18.676 12.0268 18.467 12.2908 18.467H14.1218C17.7758 18.467 17.6958 24 14.1938 24H12.2908ZM12.7948 19.443V23.025H14.1218C16.2808 23.025 16.3768 19.443 14.1218 19.443H12.7948Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9918 19.5071V20.7781H21.0308C21.3188 20.7781 21.6068 21.0661 21.6068 21.3451C21.6068 21.6091 21.3188 21.8251 21.0308 21.8251H18.9918V23.5041C18.9918 23.7841 18.7928 23.9991 18.5128 23.9991C18.1608 23.9991 17.9458 23.7841 17.9458 23.5041V18.9621C17.9458 18.6751 18.1618 18.4661 18.5128 18.4661H21.3198C21.6718 18.4661 21.8798 18.6751 21.8798 18.9621C21.8798 19.2181 21.6718 19.5061 21.3198 19.5061H18.9918V19.5071Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25 27H6V28H25C25.55 28 26 27.55 26 27V26C26 26.55 25.55 27 25 27Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.b5ebd4c3030ba679df796707bd90f549.svg";
export { ForwardRef as ReactComponent };